import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupActionService } from "../../shared/group-action.service";
import { GroupActionPortalNotificationRequest } from "../../shared/GroupActionPortalNotificationRequest";

@Component({
	selector: "app-sgadd-portal-notification",
	templateUrl: "./sgadd-portal-notification.component.html",
	styleUrls: ["./sgadd-portal-notification.component.css"],
})
export class SGAddPortalNotificationComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: GroupActionService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
	}

	///////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////

	user: any;
	SelectedGroup: any;

	ParentPortalSendNotification: boolean = true;
	StudentPortalSendNotification: boolean = true;
	Message: string = "";

	Processing: boolean = false;
	errorMessage: string = "";

	///////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////

	onAdd() {
		if (this.ParentPortalSendNotification == false && this.StudentPortalSendNotification == false) {
			this.errorMessage = "Select an app to send a message to";
			return;
		}
		if (this.Message == "") {
			this.errorMessage = "Enter a message to send";
			return;
		}

		var parms: GroupActionPortalNotificationRequest = {
			GroupID: this.SelectedGroup.GroupID,
			ParentPortalSendNotification: this.ParentPortalSendNotification,
			StudentPortalSendNotification: this.StudentPortalSendNotification,
			Message: this.Message,
		};

		this.Processing = true;

		var result = this.dataService.GroupActionPortalNotificationSend(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addportalnotification",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Message was sent successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addportalnotification",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send notification: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	///////////////////////////////////////////////////////////////////
}
